import { render } from "./px-grid.vue?vue&type=template&id=1a6fff96&ts=true"
import script from "./px-grid.vue?vue&type=script&lang=ts"
export * from "./px-grid.vue?vue&type=script&lang=ts"

import "./px-grid.vue?vue&type=style&index=0&id=1a6fff96&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__